import React from "react"
import * as AppConstants from "../../../../utility/AppConstants"
import 'Css/table.css'

function TabIndicatori(props: any) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE
    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_INDICATORI_ELEM_AFF_RICAVI_COMPENSI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.punteggioAffidabilitaRicaviAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.punteggioAffidabilitaRicaviAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.punteggioAffidabilitaRicaviAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.punteggioAffidabilitaRicaviAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.punteggioAffidabilitaRicaviAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_INDICATORI_ELEM_AFF_AGGIUNTO_ADDETTO}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.punteggioAffidabilitaValAggAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.punteggioAffidabilitaValAggAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.punteggioAffidabilitaValAggAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.punteggioAffidabilitaValAggAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.punteggioAffidabilitaValAggAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>

            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_INDICATORI_ELEM_AFF_REDDITO_ADDETTO}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.punteggioAffidabilitaRedditoAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.punteggioAffidabilitaRedditoAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.punteggioAffidabilitaRedditoAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.punteggioAffidabilitaRedditoAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.punteggioAffidabilitaRedditoAddetto
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_INDICATORI_ELEM_AFF_DECUMULO}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.punteggioAffidabilitaDurataScorte
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.punteggioAffidabilitaDurataScorte
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.punteggioAffidabilitaDurataScorte
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.punteggioAffidabilitaDurataScorte
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.punteggioAffidabilitaDurataScorte
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_INDICATORI_ELEM_AFF_COMPLESSIVO}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1
                                  .punteggioIndicatoriElementiAffidabilita
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2
                                  .punteggioIndicatoriElementiAffidabilita
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3
                                  .punteggioIndicatoriElementiAffidabilita
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4
                                  .punteggioIndicatoriElementiAffidabilita
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5
                                  .punteggioIndicatoriElementiAffidabilita
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
        </React.Fragment>
    )
}
export default TabIndicatori
